// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 10606-场馆运营时间查询 GET /web/v1/gym/business-time/list */
export async function getGymBusinessTimeList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGymBusinessTimeListParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOSwimGymBusinessTimeVo>(
    "/web/v1/gym/business-time/list",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 10607-场馆运营时间更新 POST /web/v1/gym/business-time/update */
export async function updateGymBusinessTime(
  body: API.SwimGymDaylyVersionUpdateReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/gym/business-time/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10601-场馆详情查询 GET /web/v1/gym/detail */
export async function getGymDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGymDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOSwimGymDetailVo>("/web/v1/gym/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 10608-场馆电价查询 GET /web/v1/gym/electricity/list */
export async function getGymElectricityList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGymElectricityListParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOListSwimGymElectricityListVo>(
    "/web/v1/gym/electricity/list",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 10609-场馆电价更新 POST /web/v1/gym/electricity/update */
export async function updateGymElectricity(
  body: API.SwimGymElectricityUpdateReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/gym/electricity/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10605-场馆文件删除 GET /web/v1/gym/file/delete/${param0} */
export async function deleteGymFile(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteGymFileParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/web/v1/gym/file/delete/${param0}`, {
    method: "GET",
    params: {
      ...queryParams,
    },
    ...(options || {}),
  });
}

/** 10602-场馆图片/视频查询 GET /web/v1/gym/file/list */
export async function getGymFileList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGymFileListParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOListSwimGymFileListVo>("/web/v1/gym/file/list", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 10604-场馆文件上传 POST /web/v1/gym/file/save */
export async function saveGymFile(
  body: API.SwimGymFileSaveReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/gym/file/save", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10603-场馆信息维护修改 POST /web/v1/gym/update */
export async function updateGymInfo(
  body: API.SwimGymUpdateReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/gym/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
